import Typography from '@mui/material/Typography';
import React from 'react';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { SurveySelectOption } from 'shared/types/survey-select-option';

import * as Styled from './survey.style';
import { SurveyOption } from './survey-option';

export type SurveyMultiSelectStepProps = {
  title: string;
  subtitle?: string;
  options: SurveySelectOption[];
  continueLabel: string;
  onContinue: () => void;
  canContinue: boolean;
  backLabel: string;
  onBack: () => void;
};

export const SurveyMultiSelectStep: React.FC<SurveyMultiSelectStepProps> = ({
  title,
  subtitle,
  options,
  continueLabel,
  onContinue,
  canContinue,
  backLabel,
  onBack,
}) => (
  <>
    <Styled.Header>
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
      {subtitle ? (
        <Styled.Subtitle>
          <Typography variant="body2">{subtitle}</Typography>
        </Styled.Subtitle>
      ) : null}
    </Styled.Header>

    <Styled.Body>
      <Styled.OptionList>
        {options.map((option) => (
          <SurveyOption
            key={option.key}
            label={option.label}
            selected={option.selected}
            onClick={option.onClick}
          />
        ))}
      </Styled.OptionList>
    </Styled.Body>

    <Styled.Interactions>
      <Button
        variant={Variants.Contained}
        size={Sizes.Medium}
        color={Colors.White}
        onClick={onBack}
      >
        {backLabel}
      </Button>
      <Button
        size={Sizes.Medium}
        color={Colors.Primary}
        onClick={onContinue}
        disabled={!canContinue}
      >
        {continueLabel}
      </Button>
    </Styled.Interactions>
  </>
);
